import type { AxiosResponse } from "axios";

import api from "services/api";

import type { BillApiRow } from "features/boletos/types";

export type FetchBillsInput = {
  page: number;
  unitInstanceId: string | undefined;
  beginDate: string | null;
  endDate: string | null;
  filterStatus: string | null;
  order: string | null;
  invoiceNumber: string | null;
};

export async function fetchBillsPage(
  input: FetchBillsInput
): Promise<{ data: BillApiRow[] | undefined; totalPages: number }> {
  const accessToken = localStorage.getItem("@UltragazEmpresarial:accessToken");
  const document = localStorage.getItem("@UltragazEmpresarial:document");

  if (!accessToken || !document) {
    throw new Error("Token de acesso ou documento não encontrado.");
  }

  const headers = { access_token: accessToken };

  const params: Record<string, string | number | null | undefined> = {
    document,
    "invoice-number": input.invoiceNumber,
    "begin-due-date": input.beginDate,
    "end-due-date": input.endDate,
    "unit-id": input.unitInstanceId,
    _offset: input.page ? input.page - 1 : 0,
    _limit: 10,
    _expand: "installment",
    _order_by: input.order,
  };

  if (input.filterStatus && input.filterStatus.toLowerCase() !== "todos") {
    params.status = input.filterStatus;
  }

  const res: AxiosResponse<BillApiRow[]> = await api.get(
    "industrial/bill/v1/bills",
    { headers, params }
  );

  return {
    data: res.data,
    totalPages: Number(res.headers["total-pages"]),
  };
}
